import { IOEM } from "@/Common/interfaces/location";
import { ITiers } from "../../../../types/spiffSetup";
import { TAction } from "../../reducer";
import EligibilityTiers from "../EligibilityTiers";

interface IEditModeTradesDialogProps {
	tiers: ITiers[];
	pvrType: string;
	applyTiersRetroactively: boolean;
	updateEligibilityRequirements: (updatedState: TAction) => void;
	oems: IOEM[];
	franchises: string[];
}

const EditModeTradesDialog = (props: IEditModeTradesDialogProps) => {
	const { tiers, pvrType, updateEligibilityRequirements, applyTiersRetroactively, oems, franchises } = props;
	return (
		<EligibilityTiers
			oems={oems}
			type="trades"
			pvrType={pvrType}
			tiers={tiers}
			updateEligibilityRequirements={updateEligibilityRequirements}
			applyTiersRetroactively={applyTiersRetroactively}
			franchises={franchises}
		/>
	);
};

export default EditModeTradesDialog;
